var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseSliderIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    draggable: "false",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 23C13.4477 23 13 22.5523 13 22C13 21.4477 13.4477 21 14 21C14.5523 21 15 21.4477 15 22C15 22.5523 14.5523 23 14 23Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4845 30.4853C30.0939 30.8758 29.4608 30.8758 29.0702 30.4853L13.5139 14.9289C13.1234 14.5384 13.1234 13.9052 13.5139 13.5147C13.9044 13.1242 14.5376 13.1242 14.9281 13.5147L30.4845 29.0711C30.875 29.4616 30.875 30.0948 30.4845 30.4853Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5157 30.4854C13.1252 30.0949 13.1252 29.4617 13.5157 29.0712L29.072 13.5149C29.4626 13.1243 30.0957 13.1243 30.4863 13.5149C30.8768 13.9054 30.8768 14.5386 30.4863 14.9291L14.9299 30.4854C14.5394 30.876 13.9062 30.876 13.5157 30.4854Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30 23C29.4477 23 29 22.5523 29 22C29 21.4477 29.4477 21 30 21C30.5523 21 31 21.4477 31 22C31 22.5523 30.5523 23 30 23Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseSliderIcon);
export default __webpack_public_path__ + "static/media/close-slider-icon.15baf874.svg";
export { ForwardRef as ReactComponent };